import { api } from '../api';

const getVehicleDevicePlateValidation = async ({ deviceTypeId, vouId, plate }) => {
  const response = await api({
    url: `Vehicles/GetPlateValidation`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: {
      DeviceTypeId: deviceTypeId,
      ProviderType: vouId,
      Plate: plate,
    },
  });
  return response.data;
};

const createVehicleExcelTemplate = async ({ customerId, deviceTypeId, vouId }) => {
  const response = await api({
    url: `Vehicles/CreateVehicleExcelTemplate`,
    method: 'POST',
    responseType: 'arraybuffer',
    data: { customerId, deviceTypeId, vouId },
  });
  return response.data;
};

const createVehicleExcelUpload = async (data) => {
  const response = await api({
    url: `Vehicles/CreateVehicleExcelUpload`,
    method: 'POST',
    data,
  });
  return response.data;
};

const addCarPlateInformationServices = {
  getVehicleDevicePlateValidation,
  createVehicleExcelTemplate,
  createVehicleExcelUpload,
};

export default addCarPlateInformationServices;
